/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Footer from '../components/Footer';
import { speak, beelineText } from '../actions';

class Faq extends React.Component {
  componentDidMount() {
    this.props.beelineText();
  }

  componentDidUpdate() {
    this.props.beelineText();
  }

  render() {
    return (
      <div className="faq-background">
        <div className="faq">
          <div className={`faq-header ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
            Frequently Asked Questions
          </div>
          <div>
            <Accordion id="q1" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">What is My Brain Explained?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>No two brains are alike.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>My Brain Explained is a suite of <b>personalized toolkits</b> that provide strategies, techonlogy, or reasources-- that help you improve how you learn or work in those specifc areas.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>You take a survey associated with each of the 13 Toolkits that will help you to understand your unique brain. Each survey takes just a few minutes to complete, with questions about a specific aspect of your brain, such as organization and planning, or how you approach preparing or studying.  The results will give you valuable <b>insight into your strengths</b> and areas to strengthen.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q2" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">Who can benefit from the My Brain Explained?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>Any adult 18+ can benefit from using My Brain Explained.</b></p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Whether you are struggling, are in a school, work or life transition, or want to optimize your potential, it is valuable to understand your unique strengths and challenges when it comes to how you learn or work.  </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  <b>&quot;There is no average brain.</b> Variability is the dominant feature of the nervous system. Like fingerprints, <b>no two brains are alike</b>. Each brain is a complex, interconnected web that is sculpted and influenced by genetics and interactions with the environment.&quot; <span style={{ fontSize: 7 }}>(CAST (2018). UDL and the learning brain. Wakefield, MA: Author. Retrieved from http://www.cast.org/our-work/publications/2018/udl-learning-brain-neuroscience.html</span>
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q3" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How can faculty, teachers, and supervisors use the MBE Suite to support their students and employees?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  In the Classroom:
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  The My Brain Explained suite of tools will include a <b>Classroom Compass</b> (coming soon - January 2022) for faculty or educators in colleges and universities which will provide <b>a heat map of the variability in your classroom</b>.
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  When faculty understand what variability looks like in their classroom, they can use Universal Design for Learning principles to design their curriculum, instruction, and assessment so that it is flexible and responsive to the individual differences in their classrooms.
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  Armed with these insights, faculty can provide effective instruction for all rather than a “one size fits all” or “teaching to the average” approach.
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  In the Workplace:
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  In the workplace context, supervisors and talent developers will use the <b>Workplace Compass</b> (coming soon - January 2022) to <b>gain insight into employee variability</b>, strengths and areas of challenge.
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  This will provide for more effective training and <b>professional development</b>, supervision and mentoring, and better designs for all, also by driving universally designed solutions.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q4" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">Do I have to be in college or working in a job to benefit from the MBE Suite?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>No</b> you don’t need to be in college or working in a job to benefit from My Brain Explained.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Regardless what your goals and aspirations are, My Brain Explained is a useful tool for enhancing your individual potential. The suite of tools can be used at any point in your life, and can be used one time, or used in an ongoing way as a roadmap for your growth.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}> It may be particularly useful when you are in transition-- like applying for college, choosing your major, returning to college, entering a retraining program, seeking your first job, seeking a promotion, or switching careers. It can provide a way of tracking your progress as you get closer to your goals.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q5" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">What is a My Brain Explained and what can it do for me?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>My Brain Explained currently consists of <b>13 MBE tools</b> that survey you on how you feel you do on a variety of cognitive skills such as organizing, planning, and prioritizing my work, my reading, my writing, my digital life, and my communication. More are underway.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Once you complete the brief self report survey, your results will be provided in a <b>personalized toolkit</b> that contains a summary of your strengths, and suggestions for improving areas of challenge.  Each toolkit will also contain personalized solutions that provide support, scaffolding, or strengthen areas of challenge based on your responses.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>The solutions will include strategies you can use at <b>school or work</b>, technologies that might be useful, and resources for you to explore. The first module on organizing, planning and prioritizing will be available early in 2021.</p>.
              </AccordionDetails>
            </Accordion>
            <Accordion id="q6" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">Does My Brain Explained identify learning differences or disabilities such as ADHD or dyslexia?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>You would need a more comprehensive neuropsychological assessment</b> in order to get a clinical diagnosis that would enable you to qualify for legally based accommodations.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Even without a formal diagnosis, the toolkit of strategies, resources and technologies should <b>provide practical and immediate support for you</b> so that you can continue to thrive in school or work.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q7" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">Can I use information to advocate for accomodations at school or work?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
                  In an informal sense, MBE will enable you to <b>gain insight</b> into areas that you need additional support and may empower you to take action to design your own learning experience, talk to faculty and administrators, seek out mentors, and other student support services.
                </p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>As noted above, upon receiving the MBE results, you may <b>decide to pursue additional testing</b> that will lead to a more formal clinical diagnosis.  With that diagnosis, you may qualify for accommodations under ADA or IDEA.</p>
                <p>
                  It is our hope that <b>the MBE suite of Toolkits give all individuals free access to the rich knowledge about their brains without the time and cost</b>. You shouldn’t need to fail to access information.
                </p>

              </AccordionDetails>
            </Accordion>
            <Accordion id="q8" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How was the My Brain Explained assesment developed?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>My Brain Explained was developed with <b>research</b> from the fields of neuroscience, psychology, learning sciences and over <b>thirty years</b> of practice experience with children and adults who have struggled to reach their potential at school and work. It evaluates both the uniqueness of those who may fall through the cracks as well the pain points even the most successful professionals can experience.</p>

              </AccordionDetails>
            </Accordion>
            <Accordion id="q9" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How were the solutions in the Toolkit developed?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>The solutions provided in Potentia Institute’s toolkits were derived from over <b>thirty years</b> of practice experience with adults in postsecondary, workforce training, and work environments.  These <b>research-based solutions</b> have been used and validated in practice.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q10" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">What is the evidence-based research that underpins the Surveys and Toolkits?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <ul>
                  <li><a className="color" href="http://www.cast.org/">Universal Design for Learning</a></li>
                  <li><a className="color" href="https://digitalpromise.org/initiative/adult-learning/">Digital Promise Adult Learning Initiative</a></li>
                  <li><p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>National Academy of Sciences Press:</p></li>
                  <ul>
                    <li><a className="color" href="https://www.nap.edu/catalog/9853/how-people-learn-brain-mind-experience-and-school-expanded-edition">How People Learn I and II</a></li>
                    <li><a className="color" href="https://www.nap.edu/catalog/13398/education-for-life-and-work-developing-transferable-knowledge-and-skills">Education for Life and Work</a></li>
                  </ul>
                  <li><a className="color" href="http://www.joycefdn.org/assets/images/JoyceEmpoweringAdultsToThriveAtWork.pdf">Empowering Adults to Thrive at Work: Personal Success Skills for 21st Century Jobs: SRI and the Joyce Foundation</a></li>
                  <li><a className="color" href="http://researchmap.digitalpromise.org/wp-content/uploads/sites/11/2018/12/SoLPoster_v2r2.pdf">Institute for Applied Neuroscience</a></li>
                </ul>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q11" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How is the My Brain Explained Suite different from other assessments?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>MBE is not a personality assessment like Meyers Briggs or Strengths Finder.  Nor is MBE a learning styles assessment.  MBE focuses on a person’s unique brain rather than personality differences to move the needle on individual success.  Regardless of a person’s personality characteristics or personality strengths, they may still struggle with essential skills and behaviors that interfere reaching their full potential.</p>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Individuals must be able to function in the workplace, get along with others, communicate and manager their own behavior.  MBE assess 13 areas of cognition that are important to success in school, work and life such as organizing, planning, prioritizing, reading comprehension, writing, communicating, problem solving etc. </p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q13" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">Will my results be secure and private?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>All of your data including your personal account information, your survey and results will be kept <b>secure and private</b>.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q14" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How long will my results be saved?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Results for public accounts will be kept for <b>12 months</b>, with an option at that time, to continue with the program through a subscription service.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q15" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How do I access my prior assessment data?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>You can access your prior assessment data through your dashboard.</p>
              </AccordionDetails>
            </Accordion>
            <Accordion id="q16" className="acord-ans">
              <AccordionSummary
                className="summary"
                expandIcon={<AddIcon />}
                IconButtonProps={{ edge: 'start' }}
              >
                <p className="color">How do I print out or save my results?</p>
              </AccordionSummary>
              <AccordionDetails className="summaryContent">
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Your results are saved in your dashboard.  You can print out a screen shot of your Toolkit results by clicking on the button at the bottom.</p>
              </AccordionDetails>
            </Accordion>
            <div className="spacer" />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  { speechEnabled: state.speech.enabled }
);

export default connect(mapStateToProps, {
  speak, beelineText,
})(withRouter(Faq));
